import resume from '../assets/pdf/Mrutynjaya Sahoo_Resume.pdf'

export const headerData = {
    name: 'Mrutyunjaya Sahoo',
    title: "Forntend Web Developer",
    desciption:"I love programming and enjoy learning by doing. I'm excited to grow and be a helpful part of any team. ",
    image: 'https://avatars.githubusercontent.com/u/126356359?v=4',
    resumePdf: resume
}
